// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file bgauth/bgauth.proto (package lvdr.v2.bgauth, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bgauth/bgauth.proto.
 */
export const file_bgauth_bgauth: GenFile = /*@__PURE__*/
  fileDesc("ChNiZ2F1dGgvYmdhdXRoLnByb3RvEg5sdmRyLnYyLmJnYXV0aCJDChpBdXRob3JpemVCYWNrZ3JvdW5kUmVxdWVzdBITCgt3b3JrZmxvd19pZBgBIAEoCRIQCghiZ190b2tlbhgCIAEoDCIuChdSZXZva2VCYWNrZ3JvdW5kUmVxdWVzdBITCgt3b3JrZmxvd19pZBgBIAEoCSIuChtTZXRCYWNrZ3JvdW5kQWNjb3VudFJlcXVlc3QSDwoHYWxsb3dlZBgBIAEoCCIbChlMaXN0QmFja2dyb3VuZEF1dGhSZXF1ZXN0IsgBChJCYWNrZ3JvdW5kQXV0aEl0ZW0SEwoLd29ya2Zsb3dfaWQYASABKAkSFQoNYXV0aG9yaXplZF9hdBgCIAEoCRIPCgdleHBpcmVkGAMgASgIEhkKEXdha2VzX3RoaXNfZGV2aWNlGAQgASgIEhQKDHdha2VfYmxvY2tlZBgFIAEoCBIaChJ3YWtlc19vdGhlcl9kZXZpY2UYBiABKAgSEgoKZXhwaXJlc19hdBgHIAEoCRIUCgxleHBpcmVzX3Nvb24YCCABKAgiZAoWQmFja2dyb3VuZEF1dGhSZXNwb25zZRIXCg9hY2NvdW50X2FsbG93ZWQYASABKAgSMQoFaXRlbXMYAiADKAsyIi5sdmRyLnYyLmJnYXV0aC5CYWNrZ3JvdW5kQXV0aEl0ZW0iFgoUR2V0UHVzaENvbmZpZ1JlcXVlc3QiagofUmVnaXN0ZXJQdXNoU3Vic2NyaXB0aW9uUmVxdWVzdBIQCghlbmRwb2ludBgBIAEoCRIOCgZwMjU2ZGgYAiABKAwSDAoEYXV0aBgDIAEoDBIXCg9jb25zZW50X3ZlcnNpb24YBCABKAkiHwodUmVtb3ZlUHVzaFN1YnNjcmlwdGlvblJlcXVlc3Qi5gEKElB1c2hDb25maWdSZXNwb25zZRIYChB2YXBpZF9wdWJsaWNfa2V5GAEgASgJEhQKDHZhcGlkX2tleV9pZBgCIAEoCRISCgpzdWJzY3JpYmVkGAMgASgIEhsKE3dha2Vfd2luZG93X3NlY29uZHMYBCABKAUSGQoRc3Vic2NyaWJlZF9rZXlfaWQYBSABKAkSDQoFYXJtZWQYBiABKAgSFQoNZ29uZV9lbmRwb2ludBgHIAEoCRIXCg9taW5fZ2FwX3NlY29uZHMYCCABKAUSFQoNY29uc2VudF9zdGFsZRgJIAEoCCJ0Cg1TZWFsZWRPcGVuaW5nEgoKAmlkGAEgASgJEgwKBGtpbmQYAiABKAkSEgoKc3ViamVjdF9pZBgDIAEoCRIRCglvcGVuZWRfYXQYBCABKAkSEQoJY2xvc2VkX2F0GAUgASgJEg8KB291dGNvbWUYBiABKAkiKwoZTGlzdFNlYWxlZE9wZW5pbmdzUmVxdWVzdBIOCgZiZWZvcmUYASABKAkicAoaTGlzdFNlYWxlZE9wZW5pbmdzUmVzcG9uc2USLAoFaXRlbXMYASADKAsyHS5sdmRyLnYyLmJnYXV0aC5TZWFsZWRPcGVuaW5nEgwKBG5leHQYAiABKAkSFgoOcmV0ZW50aW9uX2RheXMYAyABKAVCJ1olZ2l0aHViLmNvbS9ndnM0Mi9sdmRyL3Byb3RvL3YyL2JnYXV0aGIGcHJvdG8z");

/**
 * AuthorizeBackgroundRequest arms gate 2 for one workflow. The client generates
 * the bgToken device-side, stores it wrapped to the device key, and sends it raw
 * exactly once over the authenticated, unlocked WS. The server seals the
 * live-session DEK under it (crypto.SealBackgroundDEK), persists only the sealed
 * blob + sha256(bgToken), and discards the raw token — so the server can never
 * unseal offline (no escrow). Server-side sealing reuses the audited crypto core
 * instead of reimplementing it in the browser (decision: design §12/S7).
 *
 * @generated from message lvdr.v2.bgauth.AuthorizeBackgroundRequest
 */
export type AuthorizeBackgroundRequest = Message<"lvdr.v2.bgauth.AuthorizeBackgroundRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * raw 32-byte device token; hashed + used to seal server-side, never persisted
   *
   * @generated from field: bytes bg_token = 2;
   */
  bgToken: Uint8Array;
};

/**
 * Describes the message lvdr.v2.bgauth.AuthorizeBackgroundRequest.
 * Use `create(AuthorizeBackgroundRequestSchema)` to create a new message.
 */
export const AuthorizeBackgroundRequestSchema: GenMessage<AuthorizeBackgroundRequest> = /*@__PURE__*/
  messageDesc(file_bgauth_bgauth, 0);

/**
 * RevokeBackgroundRequest deletes one workflow's authorization. An empty
 * workflow_id revokes ALL of the user's authorizations.
 *
 * @generated from message lvdr.v2.bgauth.RevokeBackgroundRequest
 */
export type RevokeBackgroundRequest = Message<"lvdr.v2.bgauth.RevokeBackgroundRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;
};

/**
 * Describes the message lvdr.v2.bgauth.RevokeBackgroundRequest.
 * Use `create(RevokeBackgroundRequestSchema)` to create a new message.
 */
export const RevokeBackgroundRequestSchema: GenMessage<RevokeBackgroundRequest> = /*@__PURE__*/
  messageDesc(file_bgauth_bgauth, 1);

/**
 * SetBackgroundAccountRequest flips gate 1 — the account master switch. Off is
 * the kill switch: every blob stops being honored at once.
 *
 * @generated from message lvdr.v2.bgauth.SetBackgroundAccountRequest
 */
export type SetBackgroundAccountRequest = Message<"lvdr.v2.bgauth.SetBackgroundAccountRequest"> & {
  /**
   * @generated from field: bool allowed = 1;
   */
  allowed: boolean;
};

/**
 * Describes the message lvdr.v2.bgauth.SetBackgroundAccountRequest.
 * Use `create(SetBackgroundAccountRequestSchema)` to create a new message.
 */
export const SetBackgroundAccountRequestSchema: GenMessage<SetBackgroundAccountRequest> = /*@__PURE__*/
  messageDesc(file_bgauth_bgauth, 2);

/**
 * @generated from message lvdr.v2.bgauth.ListBackgroundAuthRequest
 */
export type ListBackgroundAuthRequest = Message<"lvdr.v2.bgauth.ListBackgroundAuthRequest"> & {
};

/**
 * Describes the message lvdr.v2.bgauth.ListBackgroundAuthRequest.
 * Use `create(ListBackgroundAuthRequestSchema)` to create a new message.
 */
export const ListBackgroundAuthRequestSchema: GenMessage<ListBackgroundAuthRequest> = /*@__PURE__*/
  messageDesc(file_bgauth_bgauth, 3);

/**
 * @generated from message lvdr.v2.bgauth.BackgroundAuthItem
 */
export type BackgroundAuthItem = Message<"lvdr.v2.bgauth.BackgroundAuthItem"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * RFC3339
   *
   * @generated from field: string authorized_at = 2;
   */
  authorizedAt: string;

  /**
   * past the soft max-age → needs re-authorize
   *
   * @generated from field: bool expired = 3;
   */
  expired: boolean;

  /**
   * COS-14: this authorization's bgToken is held by the connection's device
   *
   * @generated from field: bool wakes_this_device = 4;
   */
  wakesThisDevice: boolean;

  /**
   * COS-14b: a wake cannot run this workflow, it runs at the next connect
   *
   * @generated from field: bool wake_blocked = 5;
   */
  wakeBlocked: boolean;

  /**
   * COS-14b: another device holds the token; false for a row with no device
   *
   * @generated from field: bool wakes_other_device = 6;
   */
  wakesOtherDevice: boolean;

  /**
   * RFC3339: authorized_at + the soft max-age (LIMIT-08)
   *
   * @generated from field: string expires_at = 7;
   */
  expiresAt: string;

  /**
   * within the warn window before expires_at, not yet expired
   *
   * @generated from field: bool expires_soon = 8;
   */
  expiresSoon: boolean;
};

/**
 * Describes the message lvdr.v2.bgauth.BackgroundAuthItem.
 * Use `create(BackgroundAuthItemSchema)` to create a new message.
 */
export const BackgroundAuthItemSchema: GenMessage<BackgroundAuthItem> = /*@__PURE__*/
  messageDesc(file_bgauth_bgauth, 4);

/**
 * BackgroundAuthResponse is the shared response for authorize/revoke/set/list —
 * the server always echoes the full current state so the client never guesses.
 *
 * @generated from message lvdr.v2.bgauth.BackgroundAuthResponse
 */
export type BackgroundAuthResponse = Message<"lvdr.v2.bgauth.BackgroundAuthResponse"> & {
  /**
   * gate 1
   *
   * @generated from field: bool account_allowed = 1;
   */
  accountAllowed: boolean;

  /**
   * @generated from field: repeated lvdr.v2.bgauth.BackgroundAuthItem items = 2;
   */
  items: BackgroundAuthItem[];
};

/**
 * Describes the message lvdr.v2.bgauth.BackgroundAuthResponse.
 * Use `create(BackgroundAuthResponseSchema)` to create a new message.
 */
export const BackgroundAuthResponseSchema: GenMessage<BackgroundAuthResponse> = /*@__PURE__*/
  messageDesc(file_bgauth_bgauth, 5);

/**
 * COS-14 Web Push wake. The device a request names is always the connection's
 * own device; a subscription for another device cannot be registered.
 *
 * @generated from message lvdr.v2.bgauth.GetPushConfigRequest
 */
export type GetPushConfigRequest = Message<"lvdr.v2.bgauth.GetPushConfigRequest"> & {
};

/**
 * Describes the message lvdr.v2.bgauth.GetPushConfigRequest.
 * Use `create(GetPushConfigRequestSchema)` to create a new message.
 */
export const GetPushConfigRequestSchema: GenMessage<GetPushConfigRequest> = /*@__PURE__*/
  messageDesc(file_bgauth_bgauth, 6);

/**
 * RegisterPushSubscriptionRequest stores this device's Web Push subscription.
 *
 * @generated from message lvdr.v2.bgauth.RegisterPushSubscriptionRequest
 */
export type RegisterPushSubscriptionRequest = Message<"lvdr.v2.bgauth.RegisterPushSubscriptionRequest"> & {
  /**
   * @generated from field: string endpoint = 1;
   */
  endpoint: string;

  /**
   * uncompressed P-256 point, 65 bytes
   *
   * @generated from field: bytes p256dh = 2;
   */
  p256dh: Uint8Array;

  /**
   * 16-byte auth secret
   *
   * @generated from field: bytes auth = 3;
   */
  auth: Uint8Array;

  /**
   * COS-14b: the wake acknowledgement text this device accepted
   *
   * @generated from field: string consent_version = 4;
   */
  consentVersion: string;
};

/**
 * Describes the message lvdr.v2.bgauth.RegisterPushSubscriptionRequest.
 * Use `create(RegisterPushSubscriptionRequestSchema)` to create a new message.
 */
export const RegisterPushSubscriptionRequestSchema: GenMessage<RegisterPushSubscriptionRequest> = /*@__PURE__*/
  messageDesc(file_bgauth_bgauth, 7);

/**
 * RemovePushSubscriptionRequest deletes this device's subscription.
 *
 * @generated from message lvdr.v2.bgauth.RemovePushSubscriptionRequest
 */
export type RemovePushSubscriptionRequest = Message<"lvdr.v2.bgauth.RemovePushSubscriptionRequest"> & {
};

/**
 * Describes the message lvdr.v2.bgauth.RemovePushSubscriptionRequest.
 * Use `create(RemovePushSubscriptionRequestSchema)` to create a new message.
 */
export const RemovePushSubscriptionRequestSchema: GenMessage<RemovePushSubscriptionRequest> = /*@__PURE__*/
  messageDesc(file_bgauth_bgauth, 8);

/**
 * PushConfigResponse is the shared response for all three push requests.
 *
 * @generated from message lvdr.v2.bgauth.PushConfigResponse
 */
export type PushConfigResponse = Message<"lvdr.v2.bgauth.PushConfigResponse"> & {
  /**
   * base64url, uncompressed point; empty when not armed
   *
   * @generated from field: string vapid_public_key = 1;
   */
  vapidPublicKey: string;

  /**
   * sha256 prefix of the public key
   *
   * @generated from field: string vapid_key_id = 2;
   */
  vapidKeyId: string;

  /**
   * this device holds a subscription row
   *
   * @generated from field: bool subscribed = 3;
   */
  subscribed: boolean;

  /**
   * @generated from field: int32 wake_window_seconds = 4;
   */
  wakeWindowSeconds: number;

  /**
   * the key id the row was made for; a mismatch means resubscribe
   *
   * @generated from field: string subscribed_key_id = 5;
   */
  subscribedKeyId: string;

  /**
   * the server can send and accept a wake
   *
   * @generated from field: bool armed = 6;
   */
  armed: boolean;

  /**
   * COS-14b: this device's dead endpoint; empty unless the row is marked gone
   *
   * @generated from field: string gone_endpoint = 7;
   */
  goneEndpoint: string;

  /**
   * COS-14b: the shortest time between two pushes to one device
   *
   * @generated from field: int32 min_gap_seconds = 8;
   */
  minGapSeconds: number;

  /**
   * COS-14b: a Register was refused for its consent_version; nothing was written
   *
   * @generated from field: bool consent_stale = 9;
   */
  consentStale: boolean;
};

/**
 * Describes the message lvdr.v2.bgauth.PushConfigResponse.
 * Use `create(PushConfigResponseSchema)` to create a new message.
 */
export const PushConfigResponseSchema: GenMessage<PushConfigResponse> = /*@__PURE__*/
  messageDesc(file_bgauth_bgauth, 9);

/**
 * COS-14b. One row per opening of a sealed store while the owner was signed out.
 * Ids and times only, never a name.
 *
 * @generated from message lvdr.v2.bgauth.SealedOpening
 */
export type SealedOpening = Message<"lvdr.v2.bgauth.SealedOpening"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * wake | file_webhook
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * purpose id or trigger id
   *
   * @generated from field: string subject_id = 3;
   */
  subjectId: string;

  /**
   * RFC3339 UTC
   *
   * @generated from field: string opened_at = 4;
   */
  openedAt: string;

  /**
   * RFC3339 UTC; empty when no end is known
   *
   * @generated from field: string closed_at = 5;
   */
  closedAt: string;

  /**
   * empty when no end is known
   *
   * @generated from field: string outcome = 6;
   */
  outcome: string;
};

/**
 * Describes the message lvdr.v2.bgauth.SealedOpening.
 * Use `create(SealedOpeningSchema)` to create a new message.
 */
export const SealedOpeningSchema: GenMessage<SealedOpening> = /*@__PURE__*/
  messageDesc(file_bgauth_bgauth, 10);

/**
 * ListSealedOpeningsRequest reads one page of the caller's own rows, newest first.
 *
 * @generated from message lvdr.v2.bgauth.ListSealedOpeningsRequest
 */
export type ListSealedOpeningsRequest = Message<"lvdr.v2.bgauth.ListSealedOpeningsRequest"> & {
  /**
   * the `next` of the previous page; empty for the first page
   *
   * @generated from field: string before = 1;
   */
  before: string;
};

/**
 * Describes the message lvdr.v2.bgauth.ListSealedOpeningsRequest.
 * Use `create(ListSealedOpeningsRequestSchema)` to create a new message.
 */
export const ListSealedOpeningsRequestSchema: GenMessage<ListSealedOpeningsRequest> = /*@__PURE__*/
  messageDesc(file_bgauth_bgauth, 11);

/**
 * @generated from message lvdr.v2.bgauth.ListSealedOpeningsResponse
 */
export type ListSealedOpeningsResponse = Message<"lvdr.v2.bgauth.ListSealedOpeningsResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.bgauth.SealedOpening items = 1;
   */
  items: SealedOpening[];

  /**
   * empty at the end
   *
   * @generated from field: string next = 2;
   */
  next: string;

  /**
   * @generated from field: int32 retention_days = 3;
   */
  retentionDays: number;
};

/**
 * Describes the message lvdr.v2.bgauth.ListSealedOpeningsResponse.
 * Use `create(ListSealedOpeningsResponseSchema)` to create a new message.
 */
export const ListSealedOpeningsResponseSchema: GenMessage<ListSealedOpeningsResponse> = /*@__PURE__*/
  messageDesc(file_bgauth_bgauth, 12);

